const OTP_BLOCKING_TIME = 'OTP_BLOCKING_TIME';
const clearOtpCountTime = () => {
    localStorage.removeItem(OTP_BLOCKING_TIME);
};
const setOtpCountBlockTime = (time, isBlock) => {
    if (time) {
        const obj = {
            startTime: new Date().getTime(),
            time,
            isBlock,
        };
        localStorage.setItem(OTP_BLOCKING_TIME, JSON.stringify(obj));
    }
    else {
        clearOtpCountTime();
    }
};
const getOtpCountTimeOrigin = () => {
    const otpTime = localStorage.getItem(OTP_BLOCKING_TIME);
    if (otpTime) {
        return JSON.parse(otpTime);
    }
    return null;
};
const setOtpCountTime = (time) => {
    const currentObj = getOtpCountTimeOrigin();
    let obj;
    if (time) {
        obj = {
            startTime: (currentObj === null || currentObj === void 0 ? void 0 : currentObj.startTime) || new Date().getTime(),
            time: time || 0,
            isBlock: currentObj === null || currentObj === void 0 ? void 0 : currentObj.isBlock,
        };
    }
    else {
        obj = {
            startTime: new Date().getTime(),
            time: 0,
            isBlock: false,
        };
    }
    localStorage.setItem(OTP_BLOCKING_TIME, JSON.stringify(obj));
};
const resetOtpCountTime = () => {
    setOtpCountTime(0);
};
const getOtpCountTime = () => {
    const otpTime = localStorage.getItem(OTP_BLOCKING_TIME);
    if (otpTime) {
        const objOtpTime = JSON.parse(otpTime);
        return objOtpTime;
    }
    return {
        startTime: new Date().getTime(),
        time: 0,
        isBlock: false,
    };
};
const isBlockingTime = () => {
    const currentTime = localStorage.getItem(OTP_BLOCKING_TIME);
    if (currentTime) {
        const objOtpTime = JSON.parse(currentTime);
        return objOtpTime.isBlock;
    }
    return false;
};
export { setOtpCountBlockTime, setOtpCountTime, resetOtpCountTime, clearOtpCountTime, getOtpCountTime, isBlockingTime, getOtpCountTimeOrigin, };
